export default __webpack_public_path__ + "static/media/Programmer-amico.8d44f807.png";